import { EventOutreachSchemaType } from "../../../schema/event-outreach.schema";

/**
 * The end date a campaign starts with on this list: the event's end date while event outreach is
 * on, otherwise none (PREC-3520). A created campaign is pre-filled with it, and a duplicated or
 * copied one takes it instead of the source campaign's own end date (PREC-4322).
 */
export const eventStopDatePrefill = (
	event: Pick<EventOutreachSchemaType, "enabled" | "endDate"> | null | undefined
): string | null => (event?.enabled ? (event.endDate ?? null) : null);
